import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "src/components/Shared/NewForms/NFTextAreaInput";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

export const StockTakingsDetailAdditional = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={12}>
          <NFTextAreaInput fieldName={"comment"} required={false} title={t("Comment")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput fieldName={"createdUser"} disabled={true} title={t("CreatedUser")} />
        </Col>
        <Col sm={6}>
          <NFDateInput fieldName={"createdDate"} disabled={true} title={t("CreatedDate")} />
        </Col>
      </Row>
    </>
  );
};
